
/* 
Site configurations. This customizer web app is deployed to multiple websites.
Each object in the array should have these properties:
    "domain":           If meant to be served with "www." then include the "www." in the domain.
                        Should be unique, the same domain should not appear in more than one site config.  
    "locale":           default translation locale for the site. used to set a separate state element
    "redirectWww":      if domain includes "www."" and user loads page without it, redirect to www?
    "formApiAddress":   relative or absolute web address. request destination for form submission. 
    "formApiFormat":    different sites receive the form submission request at different endpoints.
                            this property allows the application to differentiate:
                                - fields expected by endpoint
                                - request headers for endpoint
                                - responses expected from endpoint
                            the values do not correspond to any external lexicon, they are only used in this app.
*/
export const PROD_DOMAINS = [
    {
        domain: 'www.endlesspools.com',
        locale: 'en-us', 
        redirectWww: true,
        formApiAddress: '/pool-builder/submit',
        successPageSpa: '/thank-you-spa',
        successPagePool: '/thank-you-pool',
        formApiFormat: 'us-site' // custom API maintained by EP or a vendor
    },
    {
        domain: 'www.endlesspools.co.uk',
        locale: 'en-gb',
        redirectWww: true,
        formApiAddress: 'https://www.endlesspools.com/pool-builder/submit', // using the US form endpoint for now
        // formApiAddress: 'https://masco.secure.force.com/PAR/services/apexrest/interactions/v1', // Salesforce prod
        // formApiAddress: 'https://masco--uat.sandbox.my.salesforce-sites.com/PAR/services/apexrest/interactions/v1', // Salesforce testing
        successPageSpa: 'https://www.endlesspools.co.uk/special-offer-confirmation/',
        successPagePool: 'https://www.endlesspools.co.uk/special-offer-confirmation/',
        // formApiFormat: 'sf-public-site-guest' // format of data for Salesforce - Customer Interactions (Opportunity Type) - “Public REST API Site Guest User”
        formApiFormat: 'us-site' // format of data to send to US form endpoint
    },
    {
        domain: 'www.endlesspools.fr',
        locale: 'fr-fr',
        redirectWww: true,
        formApiAddress: '',
        successPageSpa: '',
        successPagePool: '',
        formApiFormat: ''
    }
];
